"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCalculateMode = setCalculateMode;
exports.setDoneMode = setDoneMode;
exports.calculationJobReceived = calculationJobReceived;
exports.confirmCalculation = confirmCalculation;
exports.setReadyMode = setReadyMode;
exports.setBatchSize = setBatchSize;
function setCalculateMode() {
    return {
        type: "set-calculate-mode"
    };
}
function setDoneMode() {
    return {
        type: "set-done-mode"
    };
}
function calculationJobReceived(ok) {
    return {
        type: "calculation-job-received",
        ok: ok
    };
}
function confirmCalculation(parsedInputs) {
    return {
        type: "confirm-calculation",
        parsedInputs: parsedInputs
    };
}
function setReadyMode() {
    return {
        type: "set-ready-mode"
    };
}
function setBatchSize(batchSize) {
    return {
        type: "set-batch-size",
        batchSize: batchSize
    };
}
//# sourceMappingURL=actions.js.map